// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AccountBookOutlinedSvg from "@ant-design/icons-svg/es/asn/AccountBookOutlined";
import AntdIcon from '../components/AntdIcon';

var AccountBookOutlined = function AccountBookOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookOutlinedSvg
  }));
};

AccountBookOutlined.displayName = 'AccountBookOutlined';
export default React.forwardRef(AccountBookOutlined);